/* ============================================================================
   NOA — גלריות רצות: המלצות + לוגואי תקשורת

   הבאג שתוקן כאן, שאותר במדידה לאורך מחזור שלם:
   המסלול הוא width: max-content בתוך מכולה RTL, ולכן הוא נצמד לימין:
   הקצה הימני שלו על קצה המסך וכל התוכן משתרע שמאלה, מחוץ למסך.
   תרגום שמאלה לא חושף תוכן נוסף — הוא פשוט מוציא את הרצועה מהמסך,
   ולכן השורה התרוקנה לפני שהלולאה התאפסה.
   המדידה: ב-translateX של -3293 היו אפס כרטיסים על המסך; ב--71 היו חמישה.

   התיקון נשען על שלושה דברים:
   1. direction: ltr על המכולה ועל המסלול — הרצועה מתחילה משמאל.
   2. משכפלים את הסט עד שסט אחד רחב לפחות כמו המסך — כך השורה תמיד מלאה.
   3. האנימציה מזיזה בדיוק רוחב של סט אחד (בפיקסלים נמדדים), ולא -50%.
      -50% נכון רק כשיש בדיוק שני סטים, ומרגע שמשכפלים יותר הוא נשבר.
   ========================================================================== */
(function () {
  'use strict';

  function fillTrack(track, originalSet, viewportW) {
    track.textContent = '';
    originalSet.forEach(function (n) { track.appendChild(n); });

    var setWidth = track.scrollWidth;
    if (!setWidth) return 0;

    // כמה עותקים צריך כדי שסט אחד יכסה את רוחב המסך
    var copies = Math.max(1, Math.ceil(viewportW / setWidth));
    for (var c = 1; c < copies; c++) {
      originalSet.forEach(function (n) {
        var clone = n.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    var finalSetWidth = track.scrollWidth;

    // עותק שני שלם — הלולאה מתאפסת עליו בלי שייראה קפיצה
    Array.prototype.slice.call(track.children).forEach(function (n) {
      var clone = n.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    track.style.setProperty('--nb-set', finalSetWidth + 'px');
    return finalSetWidth;
  }

  function buildQuotes() {
    var wrap = document.querySelector('.nb-proof .nb-quotes');
    if (!wrap || wrap.dataset.noaMarquee) return;
    var quotes = Array.prototype.slice.call(wrap.children);
    if (quotes.length < 3) return;

    var track = document.createElement('div');
    track.className = 'nb-marquee__track';
    wrap.appendChild(track);
    wrap.classList.add('nb-marquee');

    var w = fillTrack(track, quotes, window.innerWidth);
    track.style.animationDuration = Math.max(30, Math.round(w / 55)) + 's';
    wrap.dataset.noaMarquee = '1';
  }

  function buildLogos() {
    var track = document.querySelector('.noa-media-track');
    if (!track || track.dataset.noaMarquee) return;

    var kids = Array.prototype.slice.call(track.children);
    if (!kids.length) return;

    // התמה כבר שיכפלה את הסט; לוקחים רק את המקור כדי לא לנפח אותו פי ארבע
    var half = Math.floor(kids.length / 2);
    var original = kids;
    if (half > 0 && kids[half]) {
      var a = kids[0].querySelector ? kids[0].querySelector('img') : null;
      var b = kids[half].querySelector ? kids[half].querySelector('img') : null;
      if (a && b && a.getAttribute('src') === b.getAttribute('src')) {
        original = kids.slice(0, half);
      }
    }

    var w = fillTrack(track, original, window.innerWidth);
    track.classList.add('nb-marquee__track', 'nb-marquee__track--logos');
    track.style.animationDuration = Math.max(28, Math.round(w / 45)) + 's';
    track.dataset.noaMarquee = '1';
  }

  function init() {
    buildQuotes();
    buildLogos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
